


















































































































































































































import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import VueFileAgentPlugin, { FileRecord } from "vue-file-agent";
import { VueFileAgentComponent } from "../../../interfaces/vueFileAgent";
import { CloudFlareSource } from "../../../interfaces/plyrSources";
import { CloudflareplayerConfiguration } from "./cloudflareplayerConfiguration";
import { FileService } from "../../../services/fileService";
import ConfirmDeleteDialog from "@/components/customActions/ConfirmDeleteDialog.vue";
import * as tus from "tus-js-client";
import { plugins } from "vue-file-agent";

@Component({
    components: {
        "vue-file-agent": VueFileAgentPlugin.VueFileAgent,
        ConfirmDeleteDialog,
    },
})
export default class CloudflareplayerUploadScreen extends Vue {
    @Prop() config!: CloudflareplayerConfiguration;
    @Prop() widgetHeight!: number;

    public fileRecords: FileRecord[] = [];
    public token: string = "";
    public fileRecordsForUpload: FileRecord[] = [];
    public showUploadError: boolean = false;
    public source: CloudFlareSource | null = null;
    public videoTitle: string = "";
    public formOptions: string = "choose";
    public existingItems: CloudFlareSource[] = [];
    public selectedItem: number = 0;
    public deleteDialogActive: boolean = false;
    public fileRecordToDelete: FileRecord | null = null;
    public uploadInProgress: boolean = false;
    public encodingInProgess: boolean = false;
    public encodingProgress: number = 0.0;
    public encodingStatus: string = "Upload";
    public allowFullscreen: boolean = false;
    public allowAutoplay: boolean = false;

    public cloudflareDeleteDialogActive: boolean = false;

    public get agent() {
        return (this.$refs.vueFileAgent as unknown) as VueFileAgentComponent;
    }

    public get descriptions(): {
        hint?: string;
        uploadText: string;
        accept: string;
    } {
        return {
            hint: "widget.plyr.uploadInstructionsVideo",
            uploadText: "widget.plyr.uploadHintVideo",
            accept: ".mp4, .webm, .mkv, .mov",
        };
    }

    public async mounted() {
        plugins.tus = tus;
        if (this.$auth.isAuthenticated) {
            this.token = await this.$auth.getTokenSilently();
            this.existingItems = await FileService.getCloudflareStreams(
                this.token
            );
            if (this.existingItems.length == 0) {
                this.formOptions = "upload";
            }
        }
    }

    @Emit() uploadDone(newFile: boolean) {
        if (newFile) {
            return {
                source: {
                    ...this.source,
                    allowFullscreen: this.allowFullscreen,
                    allowAutoplay: this.allowAutoplay,
                },
            };
        }
        return {
            source: {
                ...this.existingItems[this.selectedItem],
                allowFullscreen: this.allowFullscreen,
                allowAutoplay: this.allowAutoplay,
            },
        };
    }
    public async uploadFiles() {
        // Using the default uploader. You may use another uploader instead.

        this.uploadInProgress = true;
        const res = await FileService.requestTusUrl(
            (this.fileRecordsForUpload[0].size as unknown) as string,
            (this.fileRecordsForUpload[0].name() as unknown) as string,
            this.token
        );
        await this.tusUpload(
            `/api/file/startTusUpload/`,
            { Location: res.data.Location },
            this.fileRecordsForUpload
        );
        this.source = {
            uid: res.data["stream-media-id"],
            filename: this.fileRecordsForUpload[0].name(),
        };

        this.encodingInProgess = true;

        const handle = setInterval(() => {
            if (this.source) {
                FileService.getCloudflareStreamStatus(
                    this.source.uid,
                    this.token
                ).then(r => {
                    this.encodingStatus = r.result.status.state;
                    this.encodingProgress = r.result.status.pctComplete || 0;
                    if (r.result.status.state === "ready") {
                        clearInterval(handle);
                        this.fileRecordsForUpload = [];
                        this.uploadInProgress = false;
                        this.encodingInProgess = false;
                    } else if (r.result.status.state === "error") {
                        clearInterval(handle);
                        this.$store.commit("showSnackbar", {
                            text: this.$t("widget.plyr.encodingError"),
                            color: "error",
                        });
                    }
                });
            }
        }, 1000);
    }
    public deleteUploadedFile(fileRecord: FileRecord) {
        const uploadData = { someFileId: "123" };
        // remove file record from source array

        this.agent.deleteUpload(
            fileRecord.urlValue || "",
            {},
            fileRecord,
            uploadData
        );
    }
    public filesSelected(fileRecordsNewlySelected: FileRecord[]) {
        this.fileRecordsForUpload = this.fileRecordsForUpload.concat(
            fileRecordsNewlySelected
        );
    }

    public startDelete(fileRecord: FileRecord) {
        this.fileRecordToDelete = fileRecord;
        this.deleteDialogActive = true;
    }
    public onBeforeDelete(confirmation: boolean) {
        if (this.fileRecordToDelete) {
            const i = this.fileRecordsForUpload.indexOf(
                this.fileRecordToDelete
            );
            if (i !== -1) {
                // queued file, not yet uploaded. Just remove from the arrays
                this.fileRecordsForUpload.splice(i, 1);
                const k = this.fileRecords.indexOf(this.fileRecordToDelete);
                if (k !== -1) this.fileRecords.splice(k, 1);
            } else {
                if (confirmation) {
                    this.agent.deleteFileRecord(this.fileRecordToDelete); // will trigger 'delete' event
                }
            }
            this.fileRecordToDelete = null;
            this.deleteDialogActive = false;
        }
    }
    public async fileDeleted(fileRecord: FileRecord) {
        if (fileRecord.upload.data) {
            fileRecord.urlValue =
                "/api/file/by_id/" + fileRecord.upload.data.id;
        }

        const i: number = this.fileRecordsForUpload.indexOf(fileRecord);
        if (i !== -1) {
            this.fileRecordsForUpload.splice(i, 1);
        } else {
            if (!fileRecord.error) {
                this.deleteUploadedFile(fileRecord);
            }
        }
    }
    public cloudflareDelete(confirmation: boolean) {
        if (confirmation) {
            FileService.deleteCloudflareStream(
                this.existingItems[this.selectedItem].uid,
                this.token
            );
            this.existingItems.splice(this.selectedItem, 1);
        }
        this.cloudflareDeleteDialogActive = false;
        this.selectedItem = 0;
    }

    public doTusUpload(
        url: string,
        fileRecord: FileRecord,
        headers: {},
        progressCallback: Function,
        tusOptionsFn?: Function
    ) {
        const tusOptions = tusOptionsFn ? tusOptionsFn(fileRecord) : {};
        return new Promise((resolve, reject) => {
            if (!tus) {
                return reject(
                    new Error("tus required. Please install tus-js-client")
                );
            }
            // https://github.com/tus/tus-js-client
            // Create a new tus upload
            const file = fileRecord.file;
            const upload = new tus.Upload(file, {
                headers: headers,
                endpoint: url,
                chunkSize: 50 * 1024 * 1024,
                retryDelays: tusOptions.retryDelays
                    ? tusOptions.retryDelays
                    : [0, 3000, 5000, 10000, 20000],
                metadata: tusOptions.metadata
                    ? tusOptions.metadata
                    : {
                          filename: file.name,
                          filetype: file.type,
                      },
                onError(error: Error) {
                    reject(error);
                    // console.log("Failed because: " + error)
                },
                onProgress(bytesUploaded: number, bytesTotal: number) {
                    const event = {
                        loaded: bytesUploaded,
                        total: bytesTotal,
                    } as ProgressEvent;
                    progressCallback(event);
                },
                onSuccess() {
                    resolve(upload);
                },
            });
            fileRecord.tusUpload = upload;
            // Start the upload
            upload.start();
        });
    }

    public tusUpload(
        url: string,
        headers: object,
        fileRecords: FileRecord[],
        progressFn?: (progress: number) => void,
        tusOptionsFn?: Function
    ) {
        let updateOverallProgress = () => {
            /* no op */
        };
        if (progressFn) {
            updateOverallProgress = () => {
                let prgTotal = 0;
                for (const fileRecord of fileRecords) {
                    prgTotal += fileRecord.progress() as number;
                }
                progressFn(prgTotal / fileRecords.length);
            };
        }
        const promises = [];
        for (const fileRecord of fileRecords) {
            const promise = this.doTusUpload(
                url,
                fileRecord,
                headers,
                (progressEvent: ProgressEvent) => {
                    const percentCompleted =
                        (progressEvent.loaded * 100) / progressEvent.total;
                    // do not complete until promise resolved
                    fileRecord.progress(
                        percentCompleted >= 100 ? 99.9999 : percentCompleted
                    );
                    updateOverallProgress();
                },
                tusOptionsFn
            );
            promise.then(
                () => {
                    // delete fileRecord.tusUpload;
                    fileRecord.progress(100);
                },
                err => {
                    console.log(fileRecord, err);
                }
            );
            promises.push(promise);
        }
        return Promise.all(promises);
    }
}
